import { render, staticRenderFns } from "./Child.vue?vue&type=template&id=66ab007e&"
import script from "./Child.vue?vue&type=script&lang=js&"
export * from "./Child.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ab007e')) {
      api.createRecord('66ab007e', component.options)
    } else {
      api.reload('66ab007e', component.options)
    }
    module.hot.accept("./Child.vue?vue&type=template&id=66ab007e&", function () {
      api.rerender('66ab007e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Child.vue"
export default component.exports